import { CheckboxProps } from '@givebutter/primitives/checkbox';
import { Switch } from '@givebutter/primitives/switch';
import { useCustomField } from 'components/custom-fields/CustomFieldForm';
import { toFriendlyType } from 'components/custom-fields/helpers';
import * as Form from 'components/form';

const CustomFieldNumberForm = () => {
    const methods = Form.useGivebutterFormContext();
    const { control, getValues, setValue, watch } = methods;
    const { getFormFieldPath } = useCustomField();

    const typePath = getFormFieldPath('type');
    const defaultPath = getFormFieldPath('defaultResponse');

    const watchType = watch(typePath);

    const togglePercentage: CheckboxProps['onCheckedChange'] = isChecked => {
        setValue(typePath, isChecked ? 'percentage' : 'number');
    };

    const type = getValues(typePath);
    if (toFriendlyType(type) !== 'number') {
        return null;
    }

    return (
        <>
            <Form.Container className={'gap-y-1.5'}>
                <Form.Label name={defaultPath}>Default Value</Form.Label>
                <Form.TextInputRoot
                    control={control}
                    name={defaultPath}
                    inputRootProps={{ mask: 'decimal' }}
                >
                    <Form.TextInputForm />
                </Form.TextInputRoot>
                <Form.UseFormError name={defaultPath} />
            </Form.Container>

            <Form.Container className={'gap-y-1.5'}>
                <div className={`flex w-full items-center justify-between gap-x-4`}>
                    <Form.Label name={'is-percentage'} className={'cursor-pointer'}>
                        Show number as percentage
                    </Form.Label>
                    <Switch
                        onCheckedChange={togglePercentage}
                        defaultChecked={watchType === 'percentage'}
                        checked={watchType === 'percentage'}
                        id={'is-percentage'}
                    />
                </div>
                <Form.UseFormError name={typePath} />
            </Form.Container>
        </>
    );
};

const NumberForm = CustomFieldNumberForm;

export { CustomFieldNumberForm, NumberForm };
